<dx-box #queueBox height="100%" width="100%" direction="col">
    <dxi-item baseSize="auto">
        <h2 class="page-header" [ngClass]="{ 'cc-text-center': isSmallScreen }">
            AAP Workflow Queue
            <sup class="page-help-link">
                <a [href]="helpLink" target="_blank" class="fas fa-question-circle"></a>
            </sup>
        </h2>
    </dxi-item>
    <dxi-item [ratio]="1" class="cc-white-background">
        <dx-box height="100%" width="100%" direction="col" class="workflow-queue-box cc-workflow-queue-box">
            <dxi-item baseSize="auto">
                <div class="queue-option-container">
                    <dx-select-box
                        [disabled]="isQueueOptionDisabled"
                        displayExpr="text"
                        valueExpr="id"
                        [(value)]="selectedQueueViewOptionId"
                        [dataSource]="queueViewOptions"
                        (onValueChanged)="onQueueViewOptionValueChange()"
                    ></dx-select-box>
                    <dx-button
                        text="Refresh Queue"
                        icon="refresh"
                        type="default"
                        class="button-content"
                        (onClick)="onRefreshInboxClick()"
                    ></dx-button>
                    <div *ngIf="isLiteModeDefined()" class="dx-field">
                        <div class="dx-field-label">Lite Mode:</div>
                        <div class="dx-field-switch">
                            <dx-switch [(value)]="isLiteMode" (onValueChanged)="onLiteModeValueChange()"></dx-switch>
                        </div>
                    </div>
                </div>
            </dxi-item>

            <dxi-item [ratio]="1" [visible]="isLiteModeDefined()">
                <div *dxTemplate>
                    <app-workflow-queue-datagrid
                        #workflowGrid
                        [storageKey]="'WORKFLOW_QUEUE_GRID'"
                        [isLiteMode]="isLiteMode"
                        [dataSource]="workflowQueueDataSource"
                        [queueFilters]="queueFilters"
                        (forceRefresh)="onForceRefresh($event)"
                    ></app-workflow-queue-datagrid>
                </div>
            </dxi-item>
        </dx-box>
    </dxi-item>
</dx-box>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#queueBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-lite-mode-preference
    #liteModePreference
    [defaultMode]="true"
    [storageKey]="'WORKFLOW_QUEUE_REPORT'"
    [pageName]="'AAP Workflow Queue'"
    (onLoad)="setStoredLiteMode($event)"
    (onChanged)="onLiteModePreferenceChange()"
></app-lite-mode-preference>
